import React from 'react';
import {useTranslation} from 'react-i18next';
import productShot from '../../images/login_producto.webp';

/**
 * La columna de la marca: el mismo titular de dashbo.io y la captura del listado de clientes de la
 * Agencia Demo (la del hero del sitio, sin nombres de clientes reales). Reemplaza a la foto de stock,
 * que no decía qué es Dashbo, para que pasar del sitio al alta no se sienta como cambiar de producto.
 *
 * La comparten /login, /signup y la invitación, y por eso vive aparte: importarla desde `LoginPage`
 * arrastraba `LoginButton` (y `react-router-dom`, que Jest no carga) a las pantallas de la invitación.
 * En el celular no se muestra (`_terms.scss`).
 */
export function LoginCover() {
    const {t} = useTranslation();
    return (
        <div className="login-cover">
            <div className="login-cover-copy">
                <p className="login-cover-eyebrow">{t('login.cover_eyebrow')}</p>
                <p className="login-cover-title">
                    {t('login.cover_line_1')}<br/>
                    {t('login.cover_line_2')}<br/>
                    <span className="login-cover-highlight">{t('login.cover_line_3')}</span>
                </p>
            </div>
            <div className="login-cover-shot">
                <img src={productShot} alt={t('login.cover_image_alt')}/>
            </div>
        </div>
    );
}
